import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyMenuTrigger, MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatDividerModule } from '@angular/material/divider';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { FullCalendarModule } from '@fullcalendar/angular';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FormFieldsModule } from 'app/shared/components/form-fields/form-fields.module';
import { WidgetsModule } from 'app/shared/components/widgets/widgets.module';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { SharedModule } from 'app/shared/shared.module';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { TaskApprovalComponent } from '../../tasks/task-details/task-approval/task-approval.component';
import { NotifyStakeholdersModalComponent } from '../../approvals/notify-stakeholders-modal/notify-stakeholders-modal.component';
import { TsButtonModule } from 'tsui';
import { ColumnSelectorModule } from 'app/shared/components/column-selector/column-selector.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TSIconModule } from 'tsui';
import { TaskDetailsChecklistComponent } from '@tasks/task-details/task-details-checklist/task-details-checklist.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { TaskDetailsComponent } from '@tasks/task-details/task-details.component';
import { TaskPredecessorsComponent } from '@tasks/task-details/task-predecessor/task-predecessors.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatLegacyDialogModule } from '@angular/material/legacy-dialog';
import { LegacyTaskDetailsComponent } from '@shared/modules/legacy-tasks/details/details.component';

@NgModule({
  declarations: [LegacyTaskDetailsComponent],
  exports: [LegacyTaskDetailsComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatDividerModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatChipsModule,
    ColumnSelectorModule,
    MatAutocompleteModule,
    MatTooltipModule,
    MatSelectModule,
    MatTableModule,
    MatCheckboxModule,
    DragDropModule,
    TSIconModule,
    FormFieldsModule,
    MatInputModule,
    WidgetsModule,
    FullCalendarModule,
    MatSlideToggleModule,
    MatDatepickerModule,
    MatProgressSpinnerModule,
    SharedModule,
    TaskApprovalComponent,
    NotifyStakeholdersModalComponent,
    TsButtonModule,
    TaskPredecessorsComponent,
    MatProgressBarModule,
    TaskDetailsChecklistComponent,
    TaskDetailsComponent,
    MatMenuModule,
    MatIconModule,
    MatLegacyDialogModule,
  ],
})
export class LegacyTaskDetailsModule {}
